import { render, staticRenderFns } from "./drawerDetail.vue?vue&type=template&id=b3f8776c&scoped=true&"
import script from "./drawerDetail.vue?vue&type=script&lang=js&"
export * from "./drawerDetail.vue?vue&type=script&lang=js&"
import style0 from "./drawerDetail.vue?vue&type=style&index=0&id=b3f8776c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f8776c",
  null
  
)

export default component.exports